import MainLayout from "../../components/layout/MainLayout"
import TransferMaterials from "./components/transfer-materials"

const TransferMaterialIndex = () => {
    return (
        <MainLayout>
            <TransferMaterials />
        </MainLayout>
    )
}

export default TransferMaterialIndex